export const products = [
  {
    id: 1,
    name: '侍 Oversized Kimono Jacket',
    nameJp: '侍 オーバーサイズ着物ジャケット',
    price: 2480,
    category: 'outerwear',
    description: 'Premium oversized kimono-inspired jacket featuring traditional Japanese patterns. Crafted from high-quality cotton blend with modern streetwear silhouette.',
    descriptionJp: '伝統的な日本のパターンを特徴とするプレミアムオーバーサイズの着物風ジャケット。',
    image: 'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=800&h=1000&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=800&h=1000&fit=crop',
    ],
    sizes: ['S', 'M', 'L', 'XL'],
    colors: ['Black', 'Navy', 'Burgundy'],
    featured: true,
  },
  {
    id: 2,
    name: '龍 Dragon Embroidered Hoodie',
    nameJp: '龍 ドラゴン刺繍フーディー',
    price: 1850,
    category: 'hoodies',
    description: 'Luxurious heavyweight hoodie with intricate dragon embroidery on the back. Premium fleece interior for ultimate comfort.',
    descriptionJp: '背面に複雑な龍の刺繍が施された豪華なヘビーウェイトフーディー。',
    image: 'https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=800&h=1000&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1620799140188-3b2a02fd9a77?w=800&h=1000&fit=crop',
    ],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'Charcoal', 'Off-White'],
    featured: true,
  },
  {
    id: 3,
    name: '富士 Mount Fuji Graphic Tee',
    nameJp: '富士 マウントフジグラフィックティー',
    price: 8900,
    category: 'tshirts',
    description: 'Essential premium cotton tee featuring minimalist Mount Fuji print. Relaxed fit with Japanese typography details.',
    descriptionJp: 'ミニマリストの富士山プリントをフィーチャーした必須のプレミアムコットンティー。',
    image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=800&h=1000&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?w=800&h=1000&fit=crop',
    ],
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: ['Black', 'White', 'Gray'],
    featured: false,
  },
  {
    id: 4,
    name: '夜 Tokyo Nights Bomber',
    nameJp: '夜 東京ナイトボンバー',
    price: 3200,
    category: 'outerwear',
    description: 'Exclusive satin bomber jacket with hand-painted Tokyo skyline. Limited edition piece with premium quilted lining.',
    descriptionJp: '手描きの東京のスカイラインを持つ排他的なサテンボンバージャケット。',
    image: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?w=800&h=1000&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1551028719-00167b16eac5?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=800&h=1000&fit=crop',
    ],
    sizes: ['M', 'L', 'XL'],
    colors: ['Black', 'Midnight Blue'],
    featured: true,
  },
  {
    id: 5,
    name: '桜 Cherry Blossom Sweatshirt',
    nameJp: '桜 チェリーブロッサムスウェットシャツ',
    price: 1400,
    category: 'hoodies',
    description: 'Soft heavyweight sweatshirt with subtle cherry blossom print. Vintage wash finish for authentic Japanese aesthetic.',
    descriptionJp: '微妙な桜のプリントが施されたソフトヘビーウェイトスウェットシャツ。',
    image: 'https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=800&h=1000&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=800&h=1000&fit=crop',
    ],
    sizes: ['S', 'M', 'L', 'XL'],
    colors: ['Pink', 'White', 'Gray'],
    featured: false,
  },
  {
    id: 6,
    name: '武士 Samurai Cargo Pants',
    nameJp: '武士 サムライカーゴパンツ',
    price: 1600,
    category: 'bottoms',
    description: 'Technical cargo pants with traditional Japanese rope detailing. Multiple utility pockets with premium hardware.',
    descriptionJp: '伝統的な日本のロープディテールを持つテクニカルカーゴパンツ。',
    image: 'https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?w=800&h=1000&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1473966968600-fa801b869a1a?w=800&h=1000&fit=crop',
    ],
    sizes: ['28', '30', '32', '34', '36'],
    colors: ['Black', 'Olive', 'Khaki'],
    featured: true,
  },
  {
    id: 7,
    name: '波 Wave Pattern Long Sleeve',
    nameJp: '波 ウェーブパターンロングスリーブ',
    price: 1100,
    category: 'tshirts',
    description: 'Long sleeve tee with traditional Japanese wave motif. Premium organic cotton with ribbed cuffs.',
    descriptionJp: '伝統的な日本の波のモチーフを持つ長袖ティー。',
    image: 'https://images.unsplash.com/photo-1622445275463-afa2ab738c34?w=800&h=1000&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1622445275463-afa2ab738c34?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?w=800&h=1000&fit=crop',
    ],
    sizes: ['S', 'M', 'L', 'XL'],
    colors: ['Navy', 'Black', 'Cream'],
    featured: false,
  },
  {
    id: 8,
    name: '雲 Cloud Denim Jacket',
    nameJp: '雲 クラウドデニムジャケット',
    price: 2100,
    category: 'outerwear',
    description: 'Premium selvedge denim jacket with cloud embroidery. Vintage indigo wash with Japanese-inspired details.',
    descriptionJp: '雲の刺繍が施されたプレミアムセルヴィッジデニムジャケット。',
    image: 'https://images.unsplash.com/photo-1495105787522-5334e3ffa0ef?w=800&h=1000&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1495105787522-5334e3ffa0ef?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1551028719-00167b16eac5?w=800&h=1000&fit=crop',
    ],
    sizes: ['S', 'M', 'L', 'XL'],
    colors: ['Indigo', 'Black'],
    featured: false,
  },
  {
    id: 9,
    name: '月 Moonlight Pullover',
    nameJp: '月 ムーンライトプルオーバー',
    price: 1300,
    category: 'hoodies',
    description: 'Cozy pullover with moon phase graphics. Brushed fleece interior for maximum warmth and comfort.',
    descriptionJp: '月の位相グラフィックスを持つ居心地の良いプルオーバー。',
    image: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=800&h=1000&fit=crop',
    images: [
      'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=800&h=1000&fit=crop',
      'https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=800&h=1000&fit=crop',
    ],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Black', 'Charcoal', 'Navy'],
    featured: false,
  },
];

export const categories = [
  { id: 'all', name: 'All Products', nameJp: 'すべての製品' },
  { id: 'outerwear', name: 'Outerwear', nameJp: 'アウター' },
  { id: 'hoodies', name: 'Hoodies', nameJp: 'フーディー' },
  { id: 'tshirts', name: 'T-Shirts', nameJp: 'Tシャツ' },
  { id: 'bottoms', name: 'Bottoms', nameJp: 'ボトムス' },
];
